webpackJsonp([49790051903035],{

/***/ 1524:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"/en/dbd_p/","langKey":"en"}}

/***/ })

});


// WEBPACK FOOTER //
// path---en-dbd-p-9db3a5236924653bb118.js